// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/project.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "../../customer/management/v1/service_pb";
import { file_customer_management_v1_service } from "../../customer/management/v1/service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/project.proto.
 */
export const file_inventory_v1_project: GenFile = /*@__PURE__*/
  fileDesc("ChppbnZlbnRvcnkvdjEvcHJvamVjdC5wcm90bxIMaW52ZW50b3J5LnYxIlIKB1Byb2plY3QSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRItCgdtZW1iZXJzGAMgAygLMhwuY3VzdG9tZXIubWFuYWdlbWVudC52MS5Vc2VyQrQBChBjb20uaW52ZW50b3J5LnYxQgxQcm9qZWN0UHJvdG9QAVpBZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9pbnZlbnRvcnkvdjE7aW52ZW50b3J5djGiAgNJWFiqAgxJbnZlbnRvcnkuVjHKAgxJbnZlbnRvcnlcVjHiAhhJbnZlbnRvcnlcVjFcR1BCTWV0YWRhdGHqAg1JbnZlbnRvcnk6OlYxYgZwcm90bzM", [file_customer_management_v1_service]);

/**
 * @generated from message inventory.v1.Project
 */
export type Project = Message<"inventory.v1.Project"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated customer.management.v1.User members = 3;
   */
  members: User[];
};

/**
 * Describes the message inventory.v1.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project> = /*@__PURE__*/
  messageDesc(file_inventory_v1_project, 0);

